export const GlobalVariables = {
    currencyId:1,
    countryId: 4,
    poExpectedDeliveryDays:15,
    whastAppBiCompanyId:23,
    whastAppBiModuleId:33
}